import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { Notification } from '../../../types/Notification';

export const fetchAllNotifications = async () => {
  const response = await CustomAxios.get<Notification[]>(`notifications`, {});
  const { data } = response;
  return data;
};

export function useGetAllNotifications({ enabled = true }: { enabled?: boolean }) {
  const queryKey: any = [queryKeys.allNotifications];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllNotifications(),
    placeholderData: keepPreviousData,
    refetchInterval: 1000 * 60 * 3,
  });
  return query;
}
